// 导入 JSEncrypt 类
import JSEncrypt from 'jsencrypt';
import {Base64} from 'js-base64';

// 创建 JSEncrypt 对象
const encryptor = new JSEncrypt()
// 设置公钥（RSA2）
encryptor.setPublicKey('-----BEGIN PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6KuED+KzpeVBgFyavwxm\n' +
  'rDR4wd2wC/6g0jZRzt2zkgi3pxtVPSpOKP2/O06rdazEqRXRcILwHgD/Ha5d0UhC\n' +
  'A3XtLl3faFVIw+004byovPqNcIL0K8Y4HDdOIRhjndTWNXjb9Fssw62uP5/19LE3\n' +
  'g0VGe5VWh6vqOzd4kg2DkCw4hY0fJZyN5IqvD4dPX0TK45qZLt7U/g/l4uqtH23p\n' +
  'b3JCFyhNGNjuJEwIdC9fVM/FLjSyO3pS8tKSAmXrKkQoUN/unXzE4NfOgTbLLWht\n' +
  'XoZQhPUHDOVcom7vmw3KnWUr2wzJsHG/0TBukUul+OU+5IFHOv7sAEJWqPpdJLZm\n' +
  'lwIDAQAB\n' +
  '-----END PUBLIC KEY-----');

export function encryption(data) {
  // 将明文字符串转换为 Base64 格式
  const plaintextBase64 = Base64.encode(JSON.stringify(data));
  try {
    const encryptedText = encryptor.encrypt(plaintextBase64); // 使用公钥进行加密
    return encryptedText
  } catch (error) {
  }
}






// WEBPACK FOOTER //
// ./src/utils/requestUtils.js